import { RootState, useAppDispatch, useAppSelector } from "../../redux/AppStore";
import { updateShipmentState } from "../../redux/slice/UpdateTrackingAddressSlice";

export default function ShipmentStateComponents () {
  const dispatch = useAppDispatch();
  const shipmentState: string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_state);
  
  return (
    <div className="UpdateVerifyInput">
      <label>State</label>
      <input type="text" className="form-control" placeholder="Your State" value={shipmentState} onChange={t => {
        dispatch(
          updateShipmentState(t.target.value)
        )
      }
      } />
    </div>
  );
}